import { useState } from 'react'
import { router, usePage } from '@inertiajs/react'
import { Button } from '@/components/ui/Button'
import { Textarea } from '@/components/ui/Textarea'
import TimelineItem from './TimelineItem'
import { comment_submission_path } from '@/lib/routes'

// GitHub's "Add a comment" composer at the tail of the conversation: the
// viewer's avatar, a comment box, one Comment button. Posting records a
// task event, so the comment also shows in the task's activity feed.
export default function CommentComposer({ submissionId }: { submissionId: string }) {
  const { user } = usePage<{ user: { name: string; avatar_url?: string | null } | null }>().props
  const [body, setBody] = useState('')
  const ready = body.trim().length > 0

  const post = () => {
    router.post(comment_submission_path(submissionId), { message: body }, { preserveScroll: true })
    setBody('')
  }

  return (
    <TimelineItem name={user?.name ?? ''} avatarUrl={user?.avatar_url}>
      <div className="flex flex-col gap-2 px-4 py-3">
        <p className="text-sm font-semibold text-foreground">Add a comment</p>
        <Textarea
          rows={4}
          className="min-h-20 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-chart-muted"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Add your comment here..."
        />
        <div className="flex justify-end">
          <Button size="sm" disabled={!ready} onClick={post}>Comment</Button>
        </div>
      </div>
    </TimelineItem>
  )
}
